import { editorPicks } from '@/mocks/homeData';
import type { EditorPick } from '@/pages/home/types';

const picks = editorPicks as EditorPick[];

export default function EditorPicks() {
  return (
    <section id="picks" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-6xl">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-sm text-secondary-700">
            <i className="ri-bookmark-3-line"></i>
            编辑精选
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">由编辑整理的主题片单</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            不按热度，只按「值不值得花时间」来挑。每份片单围绕一个主题，帮你在有限的时间里一次看完整组推荐。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-5">
          {picks.map((pick) => (
            <article
              key={pick.title}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 sm:flex-row sm:items-stretch"
            >
              <div className="relative h-44 w-full shrink-0 overflow-hidden sm:h-auto sm:w-52">
                <img
                  src={pick.cover}
                  alt={`${pick.title} 片单封面`}
                  title={`${pick.title} - 西瓜视频编辑精选`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex min-w-0 flex-1 flex-col p-4 md:p-5">
                <span className="inline-flex w-fit items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800">
                  <i className="ri-price-tag-3-line"></i>
                  {pick.tag}
                </span>
                <h3 className="mt-3 text-sm text-foreground-950 md:text-base">{pick.title}</h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{pick.desc}</p>
                <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-user-smile-line"></i>
                  </span>
                  {pick.editor}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}